// @flow

import React from "react";

import { isEmpty } from "ramda";

import {
  type ErrosSelecao,
  type MedidaSelecionada,
  ID_TIPO_AJUSTE_PRECO_PADRAO,
} from "../../../model";

import {
  type State,
  i18n,
  getAjustesPrecoSelecionados,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
} from "../../../state";

import SelecaoAjusteDePreco from "../configuracoes/ajusteDePreco/SelecaoAjusteDePreco";

export const criaFuncaoValidacaoSeriesComAjuste = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getAjustesPrecoSelecionados(state)))
    erros.ajustesPrecoNaoSelecionados = translate("erro.selecioneAjuste");

  return erros;
};

export const processarSeriesComAjuste = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const ajustesPreco = getAjustesPrecoSelecionados(state) || [];
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

  return medidas.flatMap(medida =>
    ajustesPreco.map(ajuste => {
      return {
        ...medida,
        tipoAjuste: exibirConfiguracoesAvancadas
          ? ajuste
          : ID_TIPO_AJUSTE_PRECO_PADRAO,
        ...analiseValorDaMedida(medida, state),
      };
    })
  );
};

const SeriesComAjuste = () => {
  return (
    <>
      <SelecaoAjusteDePreco />
    </>
  );
};

export default SeriesComAjuste;
